import React,{useEffect,useState} from 'react';
import { StyleSheet,View} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';

import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Text, BottomNavigation } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import DashboardRuta from './DashboardRuta';
import ListadoTiendas from './ListadoTiendas';

const Tab = createBottomTabNavigator();

const Dashboard = () => {

const navigation = useNavigation();



    return (
      <Tab.Navigator
      screenOptions={{
        headerShown: false,
      }}
      tabBar={({ navigation, state, descriptors, insets }) => (
        <BottomNavigation.Bar
        style={{ backgroundColor: '#fff' }}
          navigationState={state}
         safeAreaInsets={insets}
          onTabPress={({ route, preventDefault }) => {
            const event = navigation.emit({
              type: 'tabPress',
              target: route.key,
              canPreventDefault: true,
            });

            if (event.defaultPrevented) {
              preventDefault();
            } else {
             navigation.navigate(route.name, route.params)
            }
          }}
          renderIcon={({ route, focused, color }) => {
            const { options } = descriptors[route.key];
            if (options.tabBarIcon) {
              return options.tabBarIcon({ focused, color, size: 24 });
            }

            return null;
          }}
          getLabelText={({ route }) => {
            const { options } = descriptors[route.key];
            const label =
              options.tabBarLabel !== undefined
                ? options.tabBarLabel
                : options.title !== undefined
                ? options.title
                : route.title;

            return label;
          }}
        />
      )}
    >
      <Tab.Screen
        name="listadoTiendas"
        component={ListadoTiendas}
        options={{
          tabBarLabel: 'Tiendas',
          tabBarIcon: ({ color, size }) => {
            return <Icon name="store" size={size} color={color} />;
          },
        }}
      />
      <Tab.Screen
        name="dashboardRuta"
        component={DashboardRuta}
        options={{
          tabBarLabel: 'Resumen',
          tabBarIcon: ({ color, size }) => {
            return <Icon name="align-vertical-bottom" size={size} color={color} />;
          },
        }}
      />
    </Tab.Navigator>
  );
}




export default Dashboard

const styles = StyleSheet.create({
  container: { 
    
    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center'
 
  },
  HeadStyle: { 
    height: 20,
    alignContent: "center",
    color: "white",
    backgroundColor: 'white'
  },
  TableText: { 
    fontSize: 14,
    textAlign: 'center',
    color : "black",
    fontWeight: 'bold',
    backgroundColor:"#F0F8F7",
  },
  text: { 
    
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems:'center', 
    justifyContent:'center',
    backgroundColor:"#3b5998",
    textAlign: 'center' 
  },
  TituloText: { 
    fontSize: 30,
    margin: 5,
    textAlign: 'center',
    color : "black",
    fontWeight: 'bold' 
  }
});